export const MoneyString = (number) => {
  return (
    "$" +
    parseFloat(number)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
};



// WEBPACK FOOTER //
// ./src/tools/MoneyString.js